import { optionsCustomReportLanguage, optionsLanguage } from "../options";
import {
  MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_IMAGE,
  MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_VIDEO,
} from "../constants";

export const CONTENT_LANGUAGE_PRESET = {
  ALL: "ALL",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  TEMPLATES: "TEMPLATES",
  REPORT: "REPORT",
};

const CONTENT_LANGUAGE_PRESET_CODES = {
  [CONTENT_LANGUAGE_PRESET.ALL]: null,
  [CONTENT_LANGUAGE_PRESET.IMAGE]:
    MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_IMAGE,
  [CONTENT_LANGUAGE_PRESET.VIDEO]:
    MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_VIDEO,
  [CONTENT_LANGUAGE_PRESET.TEMPLATES]: ["es", "pt", "en"],
  [CONTENT_LANGUAGE_PRESET.REPORT]: optionsCustomReportLanguage.map(
    (option) => option.value
  ),
};

export const normalizeLanguageCode = (language) => {
  if (!language) return "";
  return String(language).trim().split("-")[0].toLowerCase();
};

const findOptionByStoredLanguage = ({ storedLanguage, codes }) => {
  if (!storedLanguage) return null;

  const direct = optionsLanguage.find(
    (option) => option.value === storedLanguage && codes.includes(option.value)
  );
  if (direct) return direct.value;

  const normalizedStored = normalizeLanguageCode(storedLanguage);
  const byPrefix = optionsLanguage.find(
    (option) =>
      codes.includes(option.value) &&
      normalizeLanguageCode(option.value) === normalizedStored
  );
  return byPrefix?.value ?? null;
};

export const getContentLanguagePresetCodes = ({ preset }) => {
  if (
    !Object.prototype.hasOwnProperty.call(CONTENT_LANGUAGE_PRESET_CODES, preset)
  ) {
    throw new Error(`Unknown content language preset: ${preset}`);
  }

  const presetCodes = CONTENT_LANGUAGE_PRESET_CODES[preset];

  if (!presetCodes) {
    return optionsLanguage.map((option) => option.value);
  }

  return presetCodes;
};

export const getContentLanguageOptions = ({ preset }) => {
  const codes = getContentLanguagePresetCodes({ preset });

  if (preset === CONTENT_LANGUAGE_PRESET.ALL) {
    return optionsLanguage;
  }

  return optionsLanguage.filter((option) => codes.includes(option.value));
};

export const resolveContentLanguage = ({
  storedLanguage,
  preset,
  platformLanguage,
}) => {
  const codes = getContentLanguagePresetCodes({ preset });

  const storedMatch = findOptionByStoredLanguage({
    storedLanguage,
    codes,
  });
  if (storedMatch) return storedMatch;

  const platformMatch = findOptionByStoredLanguage({
    storedLanguage: platformLanguage,
    codes,
  });
  if (platformMatch) return platformMatch;

  return codes[0] ?? "en";
};

export const ensureContentLanguageField = ({
  value,
  storedLanguage,
  preset,
  platformLanguage,
}) => {
  const codes = getContentLanguagePresetCodes({ preset });
  const valueMatch = findOptionByStoredLanguage({
    storedLanguage: value,
    codes,
  });
  if (valueMatch) return valueMatch;

  return resolveContentLanguage({
    storedLanguage,
    preset,
    platformLanguage,
  });
};
